const LS_KEY = "respina_api_base";

function isBrowser() {
  return typeof window !== "undefined" && typeof window.location !== "undefined";
}

function isLocalHost() {
  if (!isBrowser()) return false;
  const h = String(window.location.hostname || "").trim().toLowerCase();
  return h === "localhost" || h === "127.0.0.1";
}

function isLocalUrl(url) {
  if (!url || typeof url !== "string") return false;
  const u = url.trim().toLowerCase();
  return u.startsWith("http://localhost") || u.startsWith("http://127.0.0.1");
}

function isSameHostDifferentPort(url, expectedApiPort = 3100) {
  if (!isBrowser() || !url || typeof url !== "string") return false;
  try {
    const stored = new URL(url.trim());
    const currentPort = window.location.port || (window.location.protocol === "https:" ? "443" : "80");
    const storedPort = stored.port || (stored.protocol === "https:" ? "443" : "80");
    const sameHost = (stored.hostname || "").toLowerCase() === (window.location.hostname || "").toLowerCase();
    if (!sameHost) return false;
    if (storedPort === currentPort) return true;
    if (storedPort === "8080" && expectedApiPort === 3100) return true;
    return false;
  } catch {
    return false;
  }
}

export function getApiBase() {
  const API_PORT = 3100;
  const fromLs = localStorage.getItem(LS_KEY);
  if (fromLs && String(fromLs).trim()) {
    const value = String(fromLs).trim();
    if (!isLocalHost() && isLocalUrl(value)) {
      // Ignore stored localhost when deployed.
    } else if (!isLocalHost() && isSameHostDifferentPort(value, API_PORT)) {
      // Ignore stored URL that points to frontend port (e.g. :8080) instead of API :3100.
    } else {
      return value;
    }
  }

  const fromEnv = process.env.VUE_APP_API_BASE;
  if (fromEnv && String(fromEnv).trim()) return String(fromEnv).trim();

  // On server (deployed) behind nginx on 443: API is same-origin at /api
  if (!isLocalHost() && isBrowser() && window.location?.hostname) {
    const port = (window.location.port || "").toString();
    const standardPort = port === "443" || port === "80" || port === "";
    if (standardPort) return ""; // same-origin: /api/...
    const protocol = window.location.protocol || "https:";
    const host = window.location.hostname;
    return `${protocol}//${host}:${API_PORT}`;
  }

  // Local dev: backend on port 3100.
  return `http://localhost:${API_PORT}`;
}

export function setApiBase(base) {
  localStorage.setItem(LS_KEY, base);
}

